import React, { useEffect, useState } from 'react';
import SearchBar from '../../../components/Autosuggest/Autosuggest';
import _ from 'lodash';
import styles from './index.module.scss';
import { searchInventoryItemsForSupplier } from 'services';
import { fetchAllSupplierInventoryMappingsForAdmin } from 'services/api/suppliers';
import { showError } from 'utils';
import DecimalInput from 'components/DecimalInput';

const propsEqual = (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
};

const SingleOrderItem = ({
  item,
  index,
  setItem,
  disabled,
  deleteItem, 
  selectedSupplier,
  fetchDefaultSuggestions: fetchDefaultSuggestionsFromProps,
}) => {
  const [defaultSuggestions, setDefaultSuggestions] = useState<Record<string, any>[]>([]);

  const fetchDefaultSuggestions = async () => {
    if (fetchDefaultSuggestionsFromProps) {
      try {
        const suggestions = await fetchDefaultSuggestionsFromProps(selectedSupplier);
        setDefaultSuggestions(suggestions.map(suggestion => ({
          id: suggestion.inventoryItem?.objectId,
          displayName: suggestion.inventoryItem?.name,
          quantity: suggestion.inventoryItem?.lastQuantityOrdered || 1,
          cost: suggestion.cost,
          price: suggestion.inventoryItem?.price,
          supplierUnitMapping: suggestion.supplierUnit,
          producerUnitMapping: suggestion.inventoryItem?.unit?.description,
          category: {
            displayName: suggestion.inventoryItem?.category?.description,
          },
          image: suggestion.inventoryItem?.image?.url,
          inventoryNameForSupplier: suggestion.inventoryNameForSupplier,
        })));
      } catch (e) {
        showError(e);
      }
    }
  };

  useEffect(() => {
    if (selectedSupplier.length) fetchDefaultSuggestions();
  }, [selectedSupplier, item.name]);

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
    item.id = suggestion.id;
    item.name = suggestion.displayName;
    item.cost = suggestion.cost;
    item.price = suggestion.price;
    item.quantity = suggestion.quantity;
    item.supplierUnitMapping =  suggestion.supplierUnitMapping;
    item.producerUnitMapping = suggestion.producerUnitMapping;
    if (suggestion.inventoryNameForSupplier) {
      item.inventoryNameForSupplier = suggestion.inventoryNameForSupplier;
    }
    setItem(item, index);
  };

  const getDelete = () => (
    <div className={styles['delete']}>
      <i
        onClick={() => deleteItem(index)}
        className='fa fa-trash-o'
      />
    </div>
  );
  
  const getProducerMapping = () => (
    <div className={styles['producer-mapping']}>
      <div className={styles['label']}>Producer Unit Mapping</div>
      <div>{item.producerUnitMapping}</div>
    </div>
  );
  
  const getSupplierMapping = () => (
    <div className={styles['supplier-mapping']}>
      <div className={styles['label']}>Supplier Unit Mapping</div>
      <div>{item.supplierUnitMapping}</div>
    </div>
  );
  
  const getTotalCost = () => (
    <div className={styles['item-total-cost']}>
      <div className={styles['total-cost']}>
        <div className={styles['label']}>Total Cost</div>
        <input
          value={item.cost * item.quantity || 0}
          type={'number'}
          disabled={true}
          className='form-control'
        />
      </div>
    </div>

  );
  
  const getQuantity = () => (
    <div className={styles['item-quantity']}>
      <div className={styles['quantity']}>
        <div className={styles['label']}>Quantity</div>
        <DecimalInput
          value={item.quantity || ''}
          disabled={disabled}
          step={1}
          onChange={val => setItem({ ...item, quantity: val }, index)}
        />
      </div>
    </div>
  );
  
  const getCost = () => (
    <div className={styles['item-cost']}>
      <div className={styles['label']}>Cost ($)</div>
      <input
        value={item.cost}
        type={'number'}
        disabled={disabled}
        step={0.1}
        onChange={e => setItem({ ...item, cost: parseFloat(e.target.value) }, index)}
        className='form-control'
      />
    </div>
  );
  
  const getPrice = () => (
    <div className={styles['item-price']}>
      <div className={styles['label']}>Price ($)</div>
      <input
        value={item.price}
        type={'number'}
        disabled={true}
        step={0.1}
        className='form-control'
      />
    </div>
  );

  const getItemDescription = () => (
    <div className={styles['item-description']}>
      <div className={styles['label']}>Description</div>
      <textarea
        value={item.description}
        disabled={disabled}
        onChange={e => setItem({ ...item, description: e.target.value }, index)}
        className='form-control'
      />
    </div>
  );
  
  const getItemName = () => (
    <div className={styles['item-name']}>
      <div className={styles['item-number']}>#{index + 1}</div>
      <div className={styles['label']}>Item Name</div>
      <SearchBar
        local={true}
        value={item.name}
        setValue={value => setItem({ ...item, name: value }, index)}
        defaultSuggestions={defaultSuggestions}
        searchAPI={searchInventoryItemsForSupplier}
        searchAPIParam={selectedSupplier}
        onSuggestionClicked={handleSuggestionClick}
      />
    </div>

  );
  
  return (
    <div className={styles['single-item']}>
      {getItemName()}
      {getItemDescription()}
      {getPrice()}
      {getCost()}
      {getQuantity()}
      {getTotalCost()}
      {getSupplierMapping()}
      {getProducerMapping()}
      {getDelete()}
    </div>
  );
};

export default React.memo(SingleOrderItem, propsEqual);
